.pill {
	border: 1px solid var(--border-primary);
}

.default {
	background-color: var(--elevation-medium);
	padding: 4px 8px;
	border-radius: 50px;
}

.outline {
	padding: 2px 6px;
	border-radius: 4px;
	background-color: var(--elevation-medium);
	color: var(--content-tertiary);
}
